<template>
    <div class="Mcp-AdvancedSimulator mcp_simulator-wrapper">

        <SimplifiedHeader 
            v-if="!pages.exit"
        />

        <TunnelSimulatorPage 
            v-if="pages.tunnel"
            :tunnelForm="tunnelForm"
            :isLeadForm="toLeadForm"
            :key="tunnelForm.name"
            :blogAnswerUrlParams="blogAnswerUrlParams"
            @Tunnel::currentStep="setCurrentStep"
        />

        <ExitSimulatorPage 
            v-if="pages.exit"
            :contentToDisplay="exitPageContent"
        />

        <ResumeSimulatorPage
            v-if="pages.resume"
            @backToLeadStep::ResumePage="_displayPage('tunnel')"
        />

        <!-- Desktop/Mobile first page -->
        <section 
            class="mobile__first-page"
            :class="{show: displayMobileFirstPage }"
        >
            <div class="container__img"> 
                <img
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    :data-src="`${mediaBaseUrl}simulator/img_mobile-sidebar.svg`"
                    class="lazyload"
                    alt=""
                />  
            </div>
            <div class="container__content">
                <img class="desktop-logo" :src="`${mediaBaseUrl}/logo.svg`" alt="logo"/>
                <h2>Trouvez l’équipement idéal et découvrez vos aides et économies !</h2>
                <p>Promis, ça ne vous prendra pas plus de 3 minutes :)</p>

                <button 
                    @click="startSimulator()"
                    class="btn btn--red btn--fill btn-primary_chevron"
                >
                    <span class="btn-label">Commencer</span>
                    <i class="icon-arrow-2"></i>
                </button>
            </div>
        </section>

    </div>
</template>

<script>
import "@/globals.js";
import "@/assets/styles/mcp/_main.scss";
import "./Simulatoradvanced.scss";

import Icon from "@/components/Icon/Icon.vue"; //Fix sprite build
import { mapActions, mapGetters } from "vuex";
import addItemToCartMixin from "@/mixins/actions/cart/addItemToCartMixin.js";
import handleDisplayMixin from "@/mixins/actions/simulator/handleDisplayMixin.js"

import SimplifiedHeader from '@/components/Header/SimplifiedHeader/SimplifiedHeader.vue';
import ExitSimulatorPage from '@/components/Simulator/ExitSimulatorPage.vue';
import TunnelSimulatorPage from '@/components/Simulator/TunnelSimulatorPage.vue';
import ResumeSimulatorPage from '@/components/Simulator/ResumeSimulatorPage.vue';


export default {
    name: "Simulatoradvanced",

    /* All display and steps stuff is in displayMixin */
    mixins: [ addItemToCartMixin, handleDisplayMixin ],

    props: ['simulatorurlparams'],

    components: {
        Icon,
        SimplifiedHeader,
        ExitSimulatorPage,
        TunnelSimulatorPage,
        ResumeSimulatorPage,
    },

    computed: {
        ...mapGetters({ 
            leadConfig: "getLeadConfig"
        }),
    },

    data() {
        return {
            mediaBaseUrl: `${process.env.VUE_APP_API_BASE_URL}/skin/frontend/mcp/default/images/`,
            blogAnswerUrlParams: {},
        };
    },


    methods: {
        /**
         * Fetch dwelling and aids Form
         */
        async fetchForms() {
            await this.setDwellingTunnelForm();
            await this.setAidsTunnelForm();

            this._displayTunnelForm('dwelling');        
        },

        /**
         * Add item rdv pac lead
         */
        async setLeadConfigDatas() {
            await this.fetchLeadConfig();
            this.addItemToCart(this.leadConfig.product ,1 , true);
        },

        startSimulator() {
            this.displayMobileFirstPage = false;
            this.pushGtmEvent();
        },

        // Gtm datalayer event
        pushGtmEvent() {
            let now = new Date();
            const urlParams         = new URLSearchParams(window.location.search);
            const ctaSourceParam    = urlParams.get('cta_source');

            let customDatas = {
                page_type: "simulateur",
                funnel_type:"simulateur2",
                cta_source: ctaSourceParam,
                timestamp: now.toLocaleString('sv-SE') + '.' + now.getMilliseconds(),
            }

            //Push
            McpGtm.pushCustomDataLayer(
                `simulator2_step1_start`,
                customDatas
            )

        },

        isFirstStepAnswered() {
            if(this.blogAnswerUrlParams && Object.keys(this.blogAnswerUrlParams).includes("mcp_home_ownership")) {
                this.displayMobileFirstPage = false;
                return true;
            }

            return false;
        },

        ...mapActions([
            "setDwellingTunnelForm",
            "setAidsTunnelForm",
            "fetchLeadConfig",
        ])
    },
    
    created() {
        this.fetchForms();
        this.setLeadConfigDatas();

        // First step answered on blog
        this.blogAnswerUrlParams = JSON.parse(this.simulatorurlparams);
        this.isFirstStepAnswered();
    },

}
</script>

<style lang="scss">
    /* Mobile first page */
    .Mcp-AdvancedSimulator .mobile__first-page {
        position: fixed;
        overflow-y: scroll;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: $color-white;
        transform: translateX(-100%);
        transition: transform .3s ease-in;

        &.show {
            transform: translateX(0);
        }
        

        .container {
            &__img {
                img {
                    width: 100%;
                }
            }

            &__content {
                padding: 5vh 10vw 0;

                .desktop-logo {
                    display: none;
                }
                
                h2 {
                    font-family: $font-family-normal;
                    font-size: 2.4rem;
                    font-weight: 500;
                    line-height: 1.2;
                    margin-bottom: 15px;
                }
        
                p {
                    font-size: 1.6rem;
                    line-height: 1.2;
                }

                button {
                    margin-top: 25px;
                }
            }    
        }

        @include breakpoint(md) {
            display: flex;
            
            .container__img {
                position: relative;
                width: 50%;
                overflow: hidden;

                img {
                    position: absolute;
                    width: auto;
                    height: 100%;
                    max-width: 500%;
                    left: -50px;
                }

            }

            .container__content {
                width: 50%;
                padding: 90px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .desktop-logo {
                    display: block;
                    position: absolute;
                    top: 50px;
                }

                h2 {
                    font-size: 3.5rem;

                    @media (orientation: landscape) {
                        font-size: 2.5rem;
                    }
                }

                p {
                    margin: 50px 0;
                    font-size: 2rem;
                }

                button {
                    width: fit-content;
                }
            }
        } 

        @include breakpoint(lg) {
            .container__img {
                width: 40%;
            }
        }
    }
</style>